<template>
  <div class="animated fadeInRight ecommerce">
    <el-row>
      <el-col :span="24">
        <el-card>
          <div slot="header" class="flex justify-between">
            <span>基本信息</span>
          </div>
          <el-table
            :data="listStoreManageInfo.listStores"
            style="width: 100%"
            border
          >
            <el-table-column prop="name" label="商户名称" align="center"></el-table-column>
            <el-table-column prop="address" label="商户地址" align="center"></el-table-column>
            <el-table-column prop="tel" label="联系电话" align="center"></el-table-column>
            <el-table-column prop="storeTypeName" label="商户类型" align="center"></el-table-column>
            <el-table-column prop="artificialPerson" label="企业法人" align="center"></el-table-column>
            <el-table-column prop="nearByLandmarks" label="附近地标" align="center"></el-table-column>
            <el-table-column label="操作" align="right">
              <template slot-scope="scope">
                <el-button
                  size="mini"
                  @click="_openEditStoreInfoModel(scope.row)"
                >修改</el-button>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-size="pageSize"
            layout="total, prev, pager, next"
            :total="total"
            class="pagination"
          ></el-pagination>
        </el-card>
      </el-col>
    </el-row>

    <el-row>
      <el-col :span="24">
        <el-card>
          <div slot="header" class="flex justify-between">
            <span>商户信息</span>
          </div>
          <el-table
            :data="listStoreManageInfo.storeAttrDtoList"
            style="width: 100%"
            border
          >
            <el-table-column prop="name" label="属性名" align="center"></el-table-column>
            <el-table-column prop="value" label="属性值" align="center"></el-table-column>
            <el-table-column label="操作" align="right">
              <template slot-scope="scope">
                <el-button
                  size="mini"
                  @click="_openEditStoreAttrModel(scope.row)"
                >修改</el-button>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-size="pageSize"
            layout="total, prev, pager, next"
            :total="total"
            class="pagination"
          ></el-pagination>
        </el-card>
      </el-col>
    </el-row>

    <edit-store-info ref="editStoreInfo"></edit-store-info>
    <edit-store-attr ref="editStoreAttr"></edit-store-attr>
  </div>
</template>

<script>
import EditStoreInfo from '@/components/common/editStoreInfo/editStoreInfo'
import EditStoreAttr from '@/components/common/editStoreAttr/editStoreAttr'
import { getStoreInfo } from '@/api/common/storeInfoManage/storeInfoManageApi'

export default {
  name: 'StoreInfoManage',
  components: {
    EditStoreInfo,
    EditStoreAttr
  },
  data() {
    return {
      listStoreManageInfo: {
        listStores: [],
        storeAttrDtoList: [],
        total: 0,
        records: 1,
        conditions: {
          name: '',
          storeTypeCd: '',
          tel: ''
        }
      },
      currentPage: 1,
      pageSize: 10
    }
  },
  created() {
    this._listListStores(this.currentPage, this.pageSize)
  },
  methods: {
    _listListStores(page, rows) {
      this.listStoreManageInfo.conditions.page = page
      this.listStoreManageInfo.conditions.row = rows
      getStoreInfo(this.listStoreManageInfo.conditions)
        .then(response => {
          this.listStoreManageInfo.listStores = response.stores
          this.listStoreManageInfo.storeAttrDtoList = this.listStoreManageInfo.listStores[0].storeAttrDtoList
          this.total = response.records
        })
        .catch(error => {
          console.error('请求失败处理', error)
        })
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this._listListStores(this.currentPage, this.pageSize)
    },
    _queryListStoreMethod() {
      this._listListStores(this.currentPage, this.pageSize)
    },
    _openEditStoreInfoModel(storeInfo) {
      this.$refs.editStoreInfo.open(storeInfo)
    },
    _openEditStoreAttrModel(storeAttr) {
      this.$refs.editStoreAttr.open(storeAttr)
    }
  }
}
</script>

<style scoped>
.pagination {
  margin-top: 15px;
  text-align: right;
}
</style>